import MUIPagination, { PaginationProps } from '@mui/material/Pagination'

export const Pagination = (props: PaginationProps) => {
  return <MUIPagination {...props} />
}
